type ClassValue = string | false | null | undefined;

/**
 * Join conditional class names.
 *
 * Deliberately tiny — no `clsx`/`tailwind-merge` dependency until a real
 * conflict-merging need shows up. Order still wins in Tailwind, so pass
 * overrides last.
 */
export function cn(...classes: ClassValue[]): string {
    return classes.filter(Boolean).join(' ');
}
